module.exports = __webpack_public_path__ + "media/images/costumes/common/select-dress-f43ce37f61fa8bc1b1a43416d012d691.png";